import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'
import LanguageStrings from '../../../i18n/locales'

export const ZData = z.object({
  id: z.string(),
  name: z.string(),
  serial_number: z.string(),
  device_type: z.string(),
  comm_type: z.string(),
  rem_bat_percent: z.string(),
  comm_mod_serial: z.string(),
  asset_state: z.string(),
  latitude: z.string(),
  longitude: z.string(),
  install_date: z.string(),
  removal_date: z.string(),
  firmware_version: z.string(),
  device_type_id: z.string(),
  ip_address: z.string(),
  port: z.string(),
  description: z.string(),
  application_type: z.string(),
  asset_model_id: z.string(),
  asset_category_id: z.string(),
  site_id: z.string(),
  asset_model_name: z.string(),
  asset_category_name: z.string(),
  communication_status: z.string(),
  hierarchy: z.string(),
  slave_id: z.number()
})

export const ZApiResponse = z.object({
  http_status: z.any(),
  data: z.optional(ZData),
  error: z.boolean(),
  error_message: z.optional(z.string())
})

export async function deviceInfoService (
  assetId: string,
  onSuccess: (device: any, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const DeviceManagementStrings = LanguageStrings().DeviceManagementCollectionStrings.TableComponent

  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  const url = `/assetrest/api/v2/udp/tiq/assets/${assetId}`

  interceptedAxios.get(url, { timeout: 15000 })
    .then((response) => {
      const parseResponse = response.data
      // istanbul ignore else
      if (parseResponse.error === false) {
        // istanbul ignore else
        if (parseResponse.data !== null && parseResponse.data !== undefined) {
          onSuccess(parseResponse.data, parseResponse.http_status)
        } else {
          onFailure(parseResponse.error, parseResponse.http_status)
        }
      } else {
        onFailure(parseResponse.error.message, response.status)
      }
    })
    .catch((error) => {
      // istanbul ignore next
      if (error.response !== undefined) {
        onFailure((error.response.data !== undefined || error.response.data !== null) ? error.response.data.error_message : DeviceManagementStrings.NetworkError, error.response.status)
      } else {
        onFailure(DeviceManagementStrings.NetworkError, 404)
      }
    })
}
